export default [
  {
    path: "/subscription-history",
    name: "subscriptionHistory",
    component: () => import("@/views/pages/subscriptionHistory/index.vue"),
  },
  {
    path: "/not-authorized",
    name: "not-authorized",
    component: () => import("@/views/pages/not-authorized/index.vue"),
  },
  {
    path: "/subscriptions",
    name: "subscriptions",
    component: () => import("@/views/pages/subscriptions/index.vue"),
  },
  {
    path: "/features",
    name: "features",
    component: () => import("@/views/pages/features/index.vue"),
  },
  {
    path: "/store",
    name: "store",
    component: () => import("@/views/pages/store/index.vue"),
  },
  {
    path: "/category-icon",
    name: "categoryIcon",
    component: () => import("@/views/pages/categoryIcon/index.vue"),
  },
  {
    path: "/accept-content-stores",
    name: "acceptContentStores",
    component: () => import("@/views/pages/acceptContent/stores.vue"),
  },
  {
    path: "/accept-content-pictures",
    name: "acceptContentPictures",
    component: () => import("@/views/pages/acceptContent/pictures.vue"),
  },
  {
    path: "/accept-content-categories",
    name: "acceptContentCategories",
    component: () => import("@/views/pages/acceptContent/categories.vue"),
  },
  {
    path: "/sms-charges-history",
    name: "smsChargesHistory",
    component: () => import("@/views/pages/smsChargesHistory/index.vue"),
  },
  {
    path: "/sms-management",
    name: "smsManagement",
    component: () => import("@/views/pages/sms-management/index.vue"),
  },
  {
    path: "/sms-management-store",
    name: "sms-management-store",
    component: () => import("@/views/pages/sms-management/store/index.vue"),
  },
  {
    path: "/accept-content-club",
    name: "acceptContentClub",
    component: () => import("@/views/pages/acceptContent/club.vue"),
  },
  {
    path: "/accept-content-products",
    name: "acceptContentProducts",
    component: () => import("@/views/pages/acceptContent/products.vue"),
  },
  {
    path: "/create-store",
    name: "createStore",
    component: () => import("@/views/pages/createStore/index.vue"),
  },
  {
    path: "/tickets",
    name: "tickets",
    component: () => import("@/views/pages/tickets/index.vue"),
  },
  {
    path: "/tickets/details",
    name: "tickets-details",
    component: () => import("@/views/pages/tickets/details/index.vue"),
  },
  {
    path: "/economic-info",
    name: "economic-info",
    component: () => import("@/views/pages/economicInfo/index.vue"),
  },
  {
    path: "/economic-info/details",
    name: "economic-info-details",
    component: () => import("@/views/pages/economicInfo/details/index.vue"),
  },
  {
    path: "/online-orders",
    name: "online-orders",
    component: () => import("@/views/pages/online-orders/index.vue"),
  },
  {
    path: "/sales-report",
    name: "sales-report",
    component: () => import("@/views/pages/sales-report/index.vue"),
  },
  {
    path: "/sms-sent-messages",
    name: "sms-sent-messages",
    component: () => import("@/views/pages/sms-sent-messages/index.vue"),
  },
  {
    path: "/total-sale",
    name: "total-sale",
    component: () => import("@/views/pages/total-sale/index.vue"),
  },
  {
    path: "/customers",
    name: "customers",
    component: () => import("@/views/pages/customers/index.vue"),
  },
  {
    path: "/customers/orders-list",
    name: "customer-orders-list",
    component: () => import("@/views/pages/customers/orders-list/index.vue"),
  },
  {
    path: "/system-manager",
    name: "system-manager",
    component: () => import("@/views/pages/system-manager/index.vue"),
  },
  {
    path: "/sending-group-sms",
    name: "sending-group-sms",
    component: () => import("@/views/pages/acceptContent/sending-group-sms.vue"),
  },
];
